import { render, staticRenderFns } from "./tingfujiRecord.vue?vue&type=template&id=282dab93&"
import script from "./tingfujiRecord.vue?vue&type=script&lang=js&"
export * from "./tingfujiRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports